import React from 'react';
import BaseApi from '../api/BaseApi.js'
import PasswordInput from './password-input.js'

export default class LoginScreen extends React.Component { 

    constructor(props) {
        super(props);
        this.state = {failed: false,
                      login: '',
                      pass: ''};
    
        this.handleChangePass = this.handleChangePass.bind(this);
        this.handleChangeLogin = this.handleChangeLogin.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChangeLogin(event) {
        this.setState({login: event.target.value});
    }

    handleChangePass(event) {
        this.setState({pass: event.target.value});
    }
    
    handleSubmit(event) {
        
        BaseApi.post('/login', {login: this.state.login, pass: this.state.pass}, {headers: {
            'Content-Type': 'application/json'}, withCredentials: true})
        .then(res => {
            const session = res.data.sessionid
            const tmppass = res.data.tmppass > 0

            if (session) {
                sessionStorage.setItem("session", res.data.sessionid)
                sessionStorage.setItem("role", res.data.role)
                if (tmppass) {
                    this.props.onNeedPassReset()
                } else {
                    this.props.onSuccess();
                }    
            } else {
                this.setState({failed: true})
            }   
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    
    render () {
        return (
        <div class = "container">  
            <div class="row mt-5">
                <div class="col-md-4 mx-auto">
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <h1>Вход в систему</h1> 
                            <form onSubmit={this.handleSubmit}>
                                <div class="form-group">
                                    <label for="login">Логин:</label>
                                    <input type="text" class="form-control" id="login" value={this.state.login} onChange={this.handleChangeLogin} />
                                    <label for="password">Пароль:</label>
                                    <PasswordInput id="password"  value={this.state.pass} onChange={this.handleChangePass} />
                                </div>
                                <button type="submit" class="btn btn-primary w-100">Вход</button>
                            </form>
                            {this.state.failed && <div class ="mt-5"><span style={{"color": "red"}}>Вход не выполнен</span></div>} 
                        </div>
                    </div>        
                    
                </div>
            </div>
        </div> )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/login-screen.js